import { createContext, useContext, useEffect, useState, ReactNode, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

interface OrgData {
  name: string;
  logo_url: string | null;
}

interface OrgContextType {
  org: OrgData | null;
  refreshOrg: () => Promise<void>;
}

const OrgContext = createContext<OrgContextType>({ org: null, refreshOrg: async () => {} });

export const useOrg = () => useContext(OrgContext);

export const OrgProvider = ({ children }: { children: ReactNode }) => {
  const { orgId } = useAuth();
  const [org, setOrg] = useState<OrgData | null>(null);

  const refreshOrg = useCallback(async () => {
    if (!orgId) return;
    const { data } = await supabase
      .from("organizations")
      .select("name, logo_url")
      .eq("id", orgId)
      .single();
    if (data) setOrg(data);
  }, [orgId]);

  useEffect(() => {
    refreshOrg();
  }, [refreshOrg]);

  return (
    <OrgContext.Provider value={{ org, refreshOrg }}>
      {children}
    </OrgContext.Provider>
  );
};
